/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SwiperComponent = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SwiperComponent, _HTMLElement);
  var _super = _createSuper(SwiperComponent);
  // The constructor is called when an object is created with the class
  function SwiperComponent() {
    var _this;
    _classCallCheck(this, SwiperComponent);
    _this = _super.call(this); // Call the parent class constructor
    _this.section = _this.querySelector('.swiper'); // Select the swiper element within the custom element
    // Retrieve the number of columns from data attributes
    _this.columnsMobile = _this.getAttribute('data-columns-mobile') || 1;
    _this.columnsDesktop = _this.getAttribute('data-columns-desktop') || 3.5;
    return _this;
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  _createClass(SwiperComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.initSwiper(); // Initialize the Swiper when the component is connected
      this.adjustSectionWidth();
      window.addEventListener('resize', function () {
        _this2.adjustSectionWidth(); // Adjust the section width on window resize
      });
    }
  }, {
    key: "adjustSectionWidth",
    value: function adjustSectionWidth() {
      var section = this.section; // Adjust selector as needed
      var progressBar = this.querySelector('.swiper-scrollbar'); // Select the progress bar element within the custom element
      var windowWidth = window.innerWidth;
      if (windowWidth > 1640) {
        var spaceRemaining = windowWidth - 1640;
        var marginLeft = spaceRemaining / 2;
        section.style.maxWidth = "".concat(1640 + marginLeft, "px");
        section.style.marginLeft = "".concat(marginLeft, "px");
        // Adjust the progress bar width to match the section width
      } else {
        section.style.maxWidth = '';
        section.style.marginLeft = '';
      }
    }

    // Method to initialize the Swiper
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      // Define the options for the Swiper
      var swiperOptions = {
        spaceBetween: 33,
        // Space between slides
        slidesPerView: parseFloat(this.columnsMobile),
        // Show 1 slide per view on screens 768px and larger
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        breakpoints: {
          768: {
            slidesPerView: parseFloat(this.columnsDesktop),
            // Show 1 slide per view on screens 768px and larger
            spaceBetween: 25
          }
        }
      };
      // Initialize the Swiper with the options
      new Swiper(this.section, swiperOptions);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Remove the event listeners when the component is disconnected
      window.removeEventListener('resize', this.adjustSectionWidth);
    }
  }]);
  return SwiperComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the custom element
customElements.define("products-swiper-component", SwiperComponent);

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;



// document.addEventListener("DOMContentLoaded", function () {

//   function waitForElements() {

//     const retailerInput = document.getElementById('company_input');
//     const retailerList = document.getElementById('company_options');
//     const countrySelect = document.getElementById('bcontact-country-531898');

//     const retailerlistDiv = document.querySelector('.retailerlist');
//     const qikifyField = document.getElementById('bcontact-Retailer-name-531898');
//     const container = document.querySelector('.bcontact-field__Retailer-name');

//     if (!countrySelect || !retailerList || !retailerInput || !retailerlistDiv || !container) {
//       setTimeout(waitForElements, 500);
//       return;
//     }

//     console.log("✅ Qikify detected");

//     const retailersByCountry = {
//   "Australia": [
//     "Alex Hindley",
//     "SCARCE & CO",
//     "STAR JEWELS PTY LTD",
//     "Time and Tide Watches",
//     "Vincent Watches & Jewellery"
//   ],
//   "Austria": [
//     "STEFFL Handels GmbH",
//     "World of Mozart Museumsbetrieb GmbH"
//   ],
//   "Bahrain": [
//     "Bahrain Jewellery Centre",
//     "Khozama Ventures WLL (10tenlabs)"
//   ],
//   "Belgium": [
//     "La Vitrine Horlogère"
//   ],
//   "Canada": [
//     "Atelier Lou"
//   ],
//   "Czech Republic": [
//     "Helveti s.r.o",
//     "Miroslav Ďorď",
//     "STABLE TRADE S.R.O"
//   ],
//   "Denmark": [
//     "Mads Svendsen",
//     "Nils Skovgaard"
//   ],
//   "France": [
//     "Berenger Store",
//     "Chamarel",
//     "Chez Maman Montres",
//     "Commande - HOREL",
//     "Horel Distribution",
//     "Jeremy Mauduit",
//     "Julien",
//     "LP3B Ocarat",
//     "Ocarat / SAV LP",
//     "Oscar Chabrat",
//     "Pause Boutique de Montres",
//     "SAMARITAINE SAS",
//     "SARL DORNIER",
//     "Sas Mig",
//     "Sullor Watch",
//     "Timekeeping",
//     "VICTOR GOUSSELAND",
//     "Windheure"
//   ],
//   "Germany": [
//     "Chronofactum",
//     "Chronorestore",
//     "Juwelier Lun",
//     "Leon Zihang",
//     "Schulz GmbH & Co KG",
//     "Tankred Taescher",
//     "Thomas Glaue",
//     "Uhren - Thor Straten",
//     "Uhrenmarkt Handels GmbH"
//   ],
//   "Hong Kong": [
//     "SNJ Limited"
//   ],
//   "India": [
//     "Ethos Limited",
//     "Ethos Ltd"
//   ],
//   "Indonesia": [
//     "PT RAW Indonesia"
//   ],
//   "Ireland": [
//     "PHILIP DOOLEY"
//   ],
//   "Italy": [
//     "Achi’ Project SRL",
//     "CENCIARINI GIOIELLERIA DI DANIELE CENCIARINI SAS",
//     "Durante Laura",
//     "Francesco",
//     "Gioielleria Angelini",
//     "Gioielleria Grande Roma srl",
//     "Gioielleria RD Preziosi",
//     "Grimoldi Milano",
//     "Lorenzo Alborghetti",
//     "Orologeria Luigi Verga Srl",
//     "Orologeria majer",
//     "Paolo Cattagni",
//     "Pasquali Domenici",
//     "RD International S.R.L.",
//     "ROSASPINA DI LUISA MARCHESI & C. - S.N.C.",
//     "Zironi Gioielleria"
//   ],
//   "Japan": [
//     "Beyond Cool Co. Ltd.",
//     "Takatoshi Iijima",
//     "UNDONE JAPAN"
//   ],
//   "Kuwait": [
//     "Time Keeper",
//     "time-keeper"
//   ],
//   "Latvia": [
//     "Istock SIA"
//   ],
//   "Malaysia": [
//     "City Chain Pte Ltd."
//   ],
//   "Mexico": [
//     "Berger",
//     "Karla Avendaño Huerta"
//   ],
//   "Netherlands": [
//     "Bernard Hunter",
//     "Dik Juwelier B.V.",
//     "Fratello Watches B.V",
//     "Juwelier van Willegen",
//     "Zironi Gioielleria"
//   ],
//   "Northern Ireland": [
//     "PRIDE AND PINION LTD"
//   ],
//   "Oman": [
//     "Al Qurum Jewellery LLC"
//   ],
//   "Peru": [
//     "Kristall Joyeria"
//   ],
//   "Philippines": [
//     "WATCHWORKS INC."
//   ],
//   "Puerto Rico": [
//     "Jose M Salas"
//   ],
//   "Qatar": [
//     "Blue Salon"
//   ],
//   "Romania": [
//     "Albini Prassa"
//   ],
//   "Saudi Arabia": [
//     "Awqat Al Ashira (10tenlabs) LLC"
//   ],
//   "Serbia": [
//     "AVENSA d.o.o. (Kazimirowa Store)"
//   ],
//   "Singapore": [
//     "Red Army Watches Pte Ltd",
//     "Time Emporium Pte Ltd",
//     "Vincent Watch Pte Ltd"
//   ],
//   "South Africa": [
//     "Kairosa Luxury Collective"
//   ],
//   "Sweden": [
//     "Fredmans Ur AB"
//   ],
//   "Switzerland": [
//     "Coveri SA",
//     "GEKKO TRADING Sàrl",
//     "Luxury Brands Switzerland SARL",
//     "Montres SA",
//     "Montrichard SA",
//     "Tea von K Sarl",
//     "Tempus la boutique",
//     "The Swiss Collector",
//     "Thomas Rüegg",
//     "Tristan Boyer de Bouillane"
//   ],
//   "Thailand": [
//     "Pendulum Ltd.",
//     "Pendulum Service Center Co. Ltd."
//   ],
//   "Turkey": [
//     "Abt Saat"
//   ],
//   "United Arab Emirates": [
//     "AHMED SEDDIQI AND SONS LLC",
//     "Artemiy Ivanovskiy",
//     "MOHAMMED ABDULMAGIED AHMED QASSIM SEDDIQI",
//     "Perpetuel Gallery Ltd",
//     "Samantha Lujano"
//   ],
//   "United Kingdom": [
//     "Anthony Rawlinson",
//     "GOLDSMITHS",
//     "Michael Simpson",
//     "Time & Tide Holdings (UK) Ltd",
//     "Wallace Allan Ltd",
//     "Watches of Mayfair Ltd.",
//     "Watches of Switzerland-UK"
//   ],
//   "United States": [
//     "Alexander Auguste",
//     "Analog Shift",
//     "Arnauld Lapierre",
//     "AZ Fine Time",
//     "AZZI Jewellery",
//     "Belmont Watches",
//     "Belmont Watches.",
//     "Chatel",
//     "Cho Chien Lin",
//     "Clicky Bezel",
//     "Daniel Ramlagan",
//     "Daniel Zaltsberg",
//     "David Houghton",
//     "ETP",
//     "Ewatchfactory Corp No2",
//     "FTS",
//     "Greenwich Time LLC",
//     "Grenon's of Newport",
//     "Hodinkee Shop.",
//     "Hoursmiths",
//     "Katie Khalsa- Cooney",
//     "Kenneth Schwartzman",
//     "Mark Zhu",
//     "Moyer Fine Jewelers",
//     "Pete Gray",
//     "Philip Crawford",
//     "Rafe Autie",
//     "Red Bar Atlanta",
//     "Right Time",
//     "Robert Arguelles",
//     "Robert Schulman",
//     "Ronaldo del Carmen",
//     "Sandeep Ganni",
//     "Sandrine Vendor",
//     "Santurce Collection",
//     "Seth Dallaire",
//     "Seung-Hyo CHOI",
//     "Sivakumar Narayanan",
//     "Steve Sakurai",
//     "Sydel & Sydel Jewelry",
//     "Teddy Baldassarre Entertainment LLC",
//     "Time Innovations LLC",
//     "Timescape USA",
//     "Watches of Switzerland Group USA Inc",
//     "Wind up watch Fair",
//     "Worn & Wound"
//   ],
//   "Vietnam": [
//     "GIA BAO LIMITED",
//     "GIA BAO LUXURY WATCH COMPANY LTD."
//   ]
// };

//     function updateRetailers() {

//       const country = countrySelect.options[countrySelect.selectedIndex]?.text?.trim();

//       retailerList.innerHTML = '';
//       retailerInput.value = '';

//       const retailers = retailersByCountry[country];

//       if (retailers && retailers.length > 0) {

//         // ✅ SHOW custom dropdown
//         retailerlistDiv.classList.remove('hide');

//         // ❌ HIDE Qikify input
//         container.classList.add('hide');

//         retailers.forEach(name => {
//           const li = document.createElement('li');
//           li.textContent = name;

//           li.addEventListener('click', () => {
//             retailerInput.value = name;
//             retailerList.style.display = 'none';
//           });

//           retailerList.appendChild(li);
//         });

//       } else {

//         // ❌ NO retailers → show normal field
//         retailerlistDiv.classList.add('hide');

//         container.classList.remove('hide');

//         // sync input only once
//         retailerInput.oninput = function () {
//           qikifyField.value = retailerInput.value;

//           qikifyField.dispatchEvent(new Event('input', { bubbles: true }));
//           qikifyField.dispatchEvent(new Event('change', { bubbles: true }));
//         };
//       }
//     }

//     countrySelect.addEventListener('change', updateRetailers);

//     updateRetailers();
//   }

//   waitForElements();
// });
document.addEventListener("DOMContentLoaded", function () {

  function waitForElements() {
    const retailerInput   = document.getElementById('company_input');
    const retailerList    = document.getElementById('company_options');
    const countrySelect   = document.getElementById('bcontact-country-531898');
    const retailerlistDiv = document.querySelector('.retailerlist');
    const qikifyField     = document.getElementById('bcontact-Retailer-name-531898');
    const container       = document.querySelector('.bcontact-field__Retailer-name');

    if (!countrySelect || !retailerList || !retailerInput || !retailerlistDiv || !container) {
      setTimeout(waitForElements, 500);
      return;
    }

    console.log("✅ Retailer script ready");

    const retailersByCountry = {
      "Australia": ["Alex Hindley","SCARCE & CO","STAR JEWELS PTY LTD","Time and Tide Watches","Vincent Watches & Jewellery"],
      "Austria": ["STEFFL Handels GmbH","World of Mozart Museumsbetrieb GmbH"],
      "Bahrain": ["Bahrain Jewellery Centre","Khozama Ventures WLL (10tenlabs)"],
      "Belgium": ["La Vitrine Horlogère"],
      "Canada": ["Atelier Lou"],
      "Czech Republic": ["Helveti s.r.o","Miroslav Ďorď","STABLE TRADE S.R.O"],
      "Denmark": ["Mads Svendsen","Nils Skovgaard"],
      "France": ["Berenger Store","Chamarel","Chez Maman Montres","Commande - HOREL","Horel Distribution","Jeremy Mauduit","Julien","LP3B Ocarat","Ocarat / SAV LP","Oscar Chabrat","Pause Boutique de Montres","SAMARITAINE SAS","SARL DORNIER","Sas Mig","Sullor Watch","Timekeeping","VICTOR GOUSSELAND","Windheure"],
      "Germany": ["Chronofactum","Chronorestore","Juwelier Lun","Leon Zihang","Schulz GmbH & Co KG","Tankred Taescher","Thomas Glaue","Uhren - Thor Straten","Uhrenmarkt Handels GmbH"],
      "Hong Kong": ["SNJ Limited"],
      "India": ["Ethos Limited","Ethos Ltd"],
      "Indonesia": ["PT RAW Indonesia"],
      "Ireland": ["PHILIP DOOLEY"],
      "Italy": ["Achi' Project SRL","CENCIARINI GIOIELLERIA DI DANIELE CENCIARINI SAS","Durante Laura","Francesco","Gioielleria Angelini","Gioielleria Grande Roma srl","Gioielleria RD Preziosi","Grimoldi Milano","Lorenzo Alborghetti","Orologeria Luigi Verga Srl","Orologeria majer","Paolo Cattagni","Pasquali Domenici","RD International S.R.L.","ROSASPINA DI LUISA MARCHESI & C. - S.N.C.","Zironi Gioielleria"],
      "Japan": ["Beyond Cool Co. Ltd.","Takatoshi Iijima","UNDONE JAPAN"],
      "Kuwait": ["Time Keeper","time-keeper"],
      "Latvia": ["Istock SIA"],
      "Malaysia": ["City Chain Pte Ltd."],
      "Mexico": ["Berger","Karla Avendaño Huerta"],
      "Netherlands": ["Bernard Hunter","Dik Juwelier B.V.","Fratello Watches B.V","Juwelier van Willegen","Zironi Gioielleria"],
      "Oman": ["Al Qurum Jewellery LLC"],
      "Peru": ["Kristall Joyeria"],
      "Philippines": ["WATCHWORKS INC."],
      "Puerto Rico": ["Jose M Salas"],
      "Qatar": ["Blue Salon"],
      "Romania": ["Albini Prassa"],
      "Saudi Arabia": ["Awqat Al Ashira (10tenlabs) LLC"],
      "Serbia": ["AVENSA d.o.o. (Kazimirowa Store)"],
      "Singapore": ["Red Army Watches Pte Ltd","Time Emporium Pte Ltd","Vincent Watch Pte Ltd"],
      "South Africa": ["Kairosa Luxury Collective"],
      "Sweden": ["Fredmans Ur AB"],
      "Switzerland": ["Coveri SA","GEKKO TRADING Sàrl","Luxury Brands Switzerland SARL","Montres SA","Montrichard SA","Tea von K Sarl","Tempus la boutique","The Swiss Collector","Thomas Rüegg","Tristan Boyer de Bouillane"],
      "Thailand": ["Pendulum Ltd.","Pendulum Service Center Co. Ltd."],
      "Turkey": ["Abt Saat"],
      "United Arab Emirates": ["AHMED SEDDIQI AND SONS LLC","Artemiy Ivanovskiy","MOHAMMED ABDULMAGIED AHMED QASSIM SEDDIQI","Perpetuel Gallery Ltd","Samantha Lujano"],
      "United Kingdom": ["Anthony Rawlinson","GOLDSMITHS","Michael Simpson","PRIDE AND PINION LTD","Time & Tide Holdings (UK) Ltd","Wallace Allan Ltd","Watches of Mayfair Ltd.","Watches of Switzerland-UK"],
      "United States": ["Alexander Auguste","Analog Shift","Arnauld Lapierre","AZ Fine Time","AZZI Jewellery","Belmont Watches","Belmont Watches.","Chatel","Cho Chien Lin","Clicky Bezel","Daniel Ramlagan","Daniel Zaltsberg","David Houghton","ETP","Ewatchfactory Corp No2","FTS","Greenwich Time LLC","Grenon's of Newport","Hodinkee Shop.","Hoursmiths","Katie Khalsa- Cooney","Kenneth Schwartzman","Mark Zhu","Moyer Fine Jewelers","Pete Gray","Philip Crawford","Rafe Autie","Red Bar Atlanta","Right Time","Robert Arguelles","Robert Schulman","Ronaldo del Carmen","Sandeep Ganni","Sandrine Vendor","Santurce Collection","Seth Dallaire","Seung-Hyo CHOI","Sivakumar Narayanan","Steve Sakurai","Sydel & Sydel Jewelry","Teddy Baldassarre Entertainment LLC","Time Innovations LLC","Timescape USA","Watches of Switzerland Group USA Inc","Wind up watch Fair","Worn & Wound"],
      "Vietnam": ["GIA BAO LIMITED","GIA BAO LUXURY WATCH COMPANY LTD."]
    };

    // ── Sync value to Qikify hidden field and fire required events ──
    function syncQikify(value) {
      qikifyField.value = value;
      qikifyField.dispatchEvent(new Event('input',  { bubbles: true }));
      qikifyField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // ── Show / hide the dropdown list ──
    function showList() { retailerList.style.display = 'block'; }
    function hideList() { retailerList.style.display = 'none';  }

    // ── Populate list items from an array of names ──
    function populateList(names) {
      retailerList.innerHTML = '';
      names.forEach(name => {
        const li = document.createElement('li');
        li.textContent = name;
        li.addEventListener('mousedown', (e) => {
          // use mousedown so it fires before the input's blur
          e.preventDefault();
          retailerInput.value = name;
          syncQikify(name);
          hideList();
        });
        retailerList.appendChild(li);
      });
    }

    // ── Main update function called on country change ──
    function updateRetailers() {
      const country = countrySelect.options[countrySelect.selectedIndex]?.text?.trim();

      retailerList.innerHTML = '';
      retailerInput.value = '';
      syncQikify('');
      hideList();

      const retailers = retailersByCountry[country];

      if (retailers && retailers.length > 0) {
        // Country has retailers → show custom dropdown, hide free-text Qikify field
        retailerlistDiv.classList.remove('hide');
        container.classList.add('hide');

        populateList(retailers);

        // Live filter as user types
        retailerInput.oninput = function () {
          const query = this.value.toLowerCase();
          const filtered = retailers.filter(r => r.toLowerCase().includes(query));
          populateList(filtered);
          syncQikify(this.value); // keep qikify in sync while typing too
          showList();
        };

        // Show full list on focus/click
        retailerInput.onfocus = function () {
          const query = this.value.toLowerCase();
          const filtered = query
            ? retailers.filter(r => r.toLowerCase().includes(query))
            : retailers;
          populateList(filtered);
          showList();
        };

        // Hide list when focus leaves the input
        retailerInput.onblur = function () {
          // small delay so mousedown on li can fire first
          setTimeout(hideList, 150);
        };

      } else {
        // No retailers for this country → hide custom dropdown, show free-text Qikify field
        retailerlistDiv.classList.add('hide');
        container.classList.remove('hide');

        // Clear handlers
        retailerInput.oninput  = null;
        retailerInput.onfocus  = null;
        retailerInput.onblur   = null;
      }
    }

    // Close dropdown if user clicks anywhere outside
    document.addEventListener('click', function (e) {
      if (!retailerlistDiv.contains(e.target)) {
        hideList();
      }
    });

    countrySelect.addEventListener('change', updateRetailers);

    // Run once on load to set initial state
    updateRetailers();
  }

  waitForElements();
});

(function () {
  'use strict';

  function initVipPurchaseForm() {
    var sel1 = document.getElementById('sel1');
    var sel2 = document.getElementById('sel2');
    var sel3 = document.getElementById('sel3');
    var companyOptions = document.getElementById('company_options');

    // Elements not in DOM yet — keep waiting
    if (!sel1 || !companyOptions) return false;

    // Prevent double-initialization on re-renders
    if (sel1.dataset.vipInit) return true;
    sel1.dataset.vipInit = '1';

    var skuField = document.querySelector('[placeholder="Watch Purchased - SKU"]');
    var resultEl = document.getElementById('result');
    var resName = document.getElementById('res-name');
    var resCol = document.getElementById('res-col');
    var companyInput = document.getElementById('company_input');
    var retailerTextField = document.querySelector('[placeholder="Retailer name"]');
    var retailerWrapper = document.querySelector('.retailerlist');

    // Fix 3: Unhide retailer dropdown wrapper
    if (retailerWrapper) retailerWrapper.classList.remove('hide');

    // Fix 2: Populate retailer custom dropdown from hidden QCF field
    var purchaseForm = window.qcfData && window.qcfData.entries &&
      window.qcfData.entries.find(function (e) { return e.id === 531898; });
    var htmlFields = purchaseForm && purchaseForm.data && purchaseForm.data.fields
      ? purchaseForm.data.fields.filter(function (f) { return f.type === 'html'; })
      : [];
    var hiddenField = htmlFields.find(function (f) { return f.hide === true; });

    if (hiddenField && companyInput && companyOptions) {
      var handles = [];
      var regex = /<li>([^<]+)<\/li>/g;
      var match;
      while ((match = regex.exec(hiddenField.html)) !== null) {
        handles.push(match[1].trim());
      }
      companyOptions.innerHTML = handles.map(function (h) {
        return '<li data-value="' + h + '">' + h + '</li>';
      }).join('');

      companyInput.addEventListener('click', function (e) {
        e.stopPropagation();
        companyOptions.style.display = companyOptions.style.display === 'block' ? 'none' : 'block';
      });
      companyInput.addEventListener('input', function () {
        var q = this.value.toLowerCase();
        companyOptions.querySelectorAll('li').forEach(function (li) {
          li.style.display = li.textContent.toLowerCase().indexOf(q) !== -1 ? '' : 'none';
        });
        companyOptions.style.display = 'block';
      });
      companyOptions.addEventListener('click', function (e) {
        var li = e.target.closest('li');
        if (!li) return;
        var val = li.getAttribute('data-value');
        companyInput.value = val;
        companyOptions.style.display = 'none';
        if (retailerTextField) {
          retailerTextField.value = val;
          retailerTextField.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      document.addEventListener('click', function () {
        companyOptions.style.display = 'none';
      });
    }

    // Fix 1: Load collections into sel1
    fetch('/collections.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var collections = data.collections || [];
        sel1.innerHTML = '<option value="">— Select —</option>' +
          collections.map(function (c) {
            return '<option value="' + c.handle + '">' + c.title + '</option>';
          }).join('');
      });

    // Collection → Products
    sel1.addEventListener('change', function () {
      sel2.innerHTML = '<option value="">— Select —</option>';
      sel3.innerHTML = '<option value="">— Select —</option>';
      sel2.disabled = sel3.disabled = true;
      if (resultEl) resultEl.classList.remove('show');
      if (!this.value) return;
      fetch('/collections/' + this.value + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.products || [];
          sel2.innerHTML = '<option value="">— Select —</option>' +
            products.map(function (p) {
              return '<option value="' + p.handle + '">' + p.title + '</option>';
            }).join('');
          sel2.disabled = false;
        });
    });

    // Product → Variants
    sel2.addEventListener('change', function () {
      sel3.innerHTML = '<option value="">— Select —</option>';
      sel3.disabled = true;
      if (resultEl) resultEl.classList.remove('show');
      if (skuField) skuField.value = '';
      if (!this.value) return;
      fetch('/products/' + this.value + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var product = data.product;
          var variants = product.variants || [];
          sel3.innerHTML = '<option value="">— Select —</option>' +
            variants.map(function (v) {
              return '<option value="' + v.id + '" data-sku="' + (v.sku || '') + '" data-title="' + v.title + '">' +
                v.title + (v.sku ? ' — ' + v.sku : '') + '</option>';
            }).join('');
          sel3.disabled = false;
        });
    });

    // Variant → auto-fill SKU + show result card
    sel3.addEventListener('change', function () {
      var opt = this.options[this.selectedIndex];
      if (!opt || !opt.value) {
        if (resultEl) resultEl.classList.remove('show');
        if (skuField) skuField.value = '';
        return;
      }
      if (skuField) {
        skuField.value = opt.dataset.sku;
        skuField.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (resultEl && resName) {
        var productName = sel2.options[sel2.selectedIndex] ? sel2.options[sel2.selectedIndex].textContent : '';
        var variantTitle = opt.dataset.title;
        resName.textContent = productName + (variantTitle !== 'Default Title' ? ' — ' + variantTitle : '');
        if (resCol) resCol.textContent = sel1.options[sel1.selectedIndex] ? sel1.options[sel1.selectedIndex].textContent : '';
        resultEl.classList.add('show');
      }
    });

    return true;
  }

  // Try immediately first (in case QCF already rendered)
  // If not ready, use MutationObserver to wait for the elements
  if (!initVipPurchaseForm()) {
    var observer = new MutationObserver(function (mutations, obs) {
      if (initVipPurchaseForm()) {
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

})();


// const retailersByCountry = {
//   "Australia": [
//     "Alex Hindley",
//     "SCARCE & CO",
//     "STAR JEWELS PTY LTD",
//     "Time and Tide Watches",
//     "Vincent Watches & Jewellery"
//   ],
//   "Austria": [
//     "STEFFL Handels GmbH",
//     "World of Mozart Museumsbetrieb GmbH"
//   ],
//   "Bahrain": [
//     "Bahrain Jewellery Centre",
//     "Khozama Ventures WLL (10tenlabs)"
//   ],
//   "Belgium": [
//     "La Vitrine Horlogère"
//   ],
//   "Canada": [
//     "Atelier Lou"
//   ],
//   "Czech Republic": [
//     "Helveti s.r.o",
//     "Miroslav Ďorď",
//     "STABLE TRADE S.R.O"
//   ],
//   "Denmark": [
//     "Mads Svendsen",
//     "Nils Skovgaard"
//   ],
//   "France": [
//     "Berenger Store",
//     "Chamarel",
//     "Chez Maman Montres",
//     "Commande - HOREL",
//     "Horel Distribution",
//     "Jeremy Mauduit",
//     "Julien",
//     "LP3B Ocarat",
//     "Ocarat / SAV LP",
//     "Oscar Chabrat",
//     "Pause Boutique de Montres",
//     "SAMARITAINE SAS",
//     "SARL DORNIER",
//     "Sas Mig",
//     "Sullor Watch",
//     "Timekeeping",
//     "VICTOR GOUSSELAND",
//     "Windheure"
//   ],
//   "Germany": [
//     "Chronofactum",
//     "Chronorestore",
//     "Juwelier Lun",
//     "Leon Zihang",
//     "Schulz GmbH & Co KG",
//     "Tankred Taescher",
//     "Thomas Glaue",
//     "Uhren - Thor Straten",
//     "Uhrenmarkt Handels GmbH"
//   ],
//   "Hong Kong": [
//     "SNJ Limited"
//   ],
//   "India": [
//     "Ethos Limited",
//     "Ethos Ltd"
//   ],
//   "Indonesia": [
//     "PT RAW Indonesia"
//   ],
//   "Ireland": [
//     "PHILIP DOOLEY"
//   ],
//   "Italy": [
//     "Achi’ Project SRL",
//     "CENCIARINI GIOIELLERIA DI DANIELE CENCIARINI SAS",
//     "Durante Laura",
//     "Francesco",
//     "Gioielleria Angelini",
//     "Gioielleria Grande Roma srl",
//     "Gioielleria RD Preziosi",
//     "Grimoldi Milano",
//     "Lorenzo Alborghetti",
//     "Orologeria Luigi Verga Srl",
//     "Orologeria majer",
//     "Paolo Cattagni",
//     "Pasquali Domenici",
//     "RD International S.R.L.",
//     "ROSASPINA DI LUISA MARCHESI & C. - S.N.C.",
//     "Zironi Gioielleria"
//   ],
//   "Japan": [
//     "Beyond Cool Co. Ltd.",
//     "Takatoshi Iijima",
//     "UNDONE JAPAN"
//   ],
//   "Kuwait": [
//     "Time Keeper",
//     "time-keeper"
//   ],
//   "Latvia": [
//     "Istock SIA"
//   ],
//   "Malaysia": [
//     "City Chain Pte Ltd."
//   ],
//   "Mexico": [
//     "Berger",
//     "Karla Avendaño Huerta"
//   ],
//   "Netherlands": [
//     "Bernard Hunter",
//     "Dik Juwelier B.V.",
//     "Fratello Watches B.V",
//     "Juwelier van Willegen",
//     "Zironi Gioielleria"
//   ],
//   "Northern Ireland": [
//     "PRIDE AND PINION LTD"
//   ],
//   "Oman": [
//     "Al Qurum Jewellery LLC"
//   ],
//   "Peru": [
//     "Kristall Joyeria"
//   ],
//   "Philippines": [
//     "WATCHWORKS INC."
//   ],
//   "Puerto Rico": [
//     "Jose M Salas"
//   ],
//   "Qatar": [
//     "Blue Salon"
//   ],
//   "Romania": [
//     "Albini Prassa"
//   ],
//   "Saudi Arabia": [
//     "Awqat Al Ashira (10tenlabs) LLC"
//   ],
//   "Serbia": [
//     "AVENSA d.o.o. (Kazimirowa Store)"
//   ],
//   "Singapore": [
//     "Red Army Watches Pte Ltd",
//     "Time Emporium Pte Ltd",
//     "Vincent Watch Pte Ltd"
//   ],
//   "South Africa": [
//     "Kairosa Luxury Collective"
//   ],
//   "Sweden": [
//     "Fredmans Ur AB"
//   ],
//   "Switzerland": [
//     "Coveri SA",
//     "GEKKO TRADING Sàrl",
//     "Luxury Brands Switzerland SARL",
//     "Montres SA",
//     "Montrichard SA",
//     "Tea von K Sarl",
//     "Tempus la boutique",
//     "The Swiss Collector",
//     "Thomas Rüegg",
//     "Tristan Boyer de Bouillane"
//   ],
//   "Thailand": [
//     "Pendulum Ltd.",
//     "Pendulum Service Center Co. Ltd."
//   ],
//   "Turkey": [
//     "Abt Saat"
//   ],
//   "United Arab Emirates": [
//     "AHMED SEDDIQI AND SONS LLC",
//     "Artemiy Ivanovskiy",
//     "MOHAMMED ABDULMAGIED AHMED QASSIM SEDDIQI",
//     "Perpetuel Gallery Ltd",
//     "Samantha Lujano"
//   ],
//   "United Kingdom": [
//     "Anthony Rawlinson",
//     "GOLDSMITHS",
//     "Michael Simpson",
//     "Time & Tide Holdings (UK) Ltd",
//     "Wallace Allan Ltd",
//     "Watches of Mayfair Ltd.",
//     "Watches of Switzerland-UK"
//   ],
//   "United States": [
//     "Alexander Auguste",
//     "Analog Shift",
//     "Arnauld Lapierre",
//     "AZ Fine Time",
//     "AZZI Jewellery",
//     "Belmont Watches",
//     "Belmont Watches.",
//     "Chatel",
//     "Cho Chien Lin",
//     "Clicky Bezel",
//     "Daniel Ramlagan",
//     "Daniel Zaltsberg",
//     "David Houghton",
//     "ETP",
//     "Ewatchfactory Corp No2",
//     "FTS",
//     "Greenwich Time LLC",
//     "Grenon's of Newport",
//     "Hodinkee Shop.",
//     "Hoursmiths",
//     "Katie Khalsa- Cooney",
//     "Kenneth Schwartzman",
//     "Mark Zhu",
//     "Moyer Fine Jewelers",
//     "Pete Gray",
//     "Philip Crawford",
//     "Rafe Autie",
//     "Red Bar Atlanta",
//     "Right Time",
//     "Robert Arguelles",
//     "Robert Schulman",
//     "Ronaldo del Carmen",
//     "Sandeep Ganni",
//     "Sandrine Vendor",
//     "Santurce Collection",
//     "Seth Dallaire",
//     "Seung-Hyo CHOI",
//     "Sivakumar Narayanan",
//     "Steve Sakurai",
//     "Sydel & Sydel Jewelry",
//     "Teddy Baldassarre Entertainment LLC",
//     "Time Innovations LLC",
//     "Timescape USA",
//     "Watches of Switzerland Group USA Inc",
//     "Wind up watch Fair",
//     "Worn & Wound"
//   ],
//   "Vietnam": [
//     "GIA BAO LIMITED",
//     "GIA BAO LUXURY WATCH COMPANY LTD."
//   ]
// };